/**
 * 全站页面壳层快捷配置：按 productKind 控制是否展示底栏等。
 * 新产品页不需要 footer 时，将 productKind 加入 hideFooterProductKinds 即可。
 */
export const pageLayoutConfig = {
  /** 不展示全站底栏（SiteFooter / StandaloneFooter）的 productKind */
  hideFooterProductKinds: ['inst_hotspot'] as const,
} as const;

export function shouldHideFooterForProductKind(
  productKind: string | undefined | null
): boolean {
  if (!productKind) {
    return false;
  }
  return (pageLayoutConfig.hideFooterProductKinds as readonly string[]).includes(
    productKind
  );
}
